import React from "react";

import { Col, Card, Button, ButtonGroup } from "react-bootstrap";
import {
  MdEdit,
  MdDone,
  MdEmail,
  MdLocalTaxi,
  MdOutlinePix,
  MdLocationCity,
  MdOutlineSpeakerNotes,
  MdOutlineImportContacts
} from "react-icons/md";

import PropTypes from "prop-types";
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { connect } from "react-redux"
import { createProvider, getPostalCode } from "../../../../store/register/provider/actions"

import Alerts from "./../../common/alerts/index"
import Step1 from "../step_1/index";
import Step2 from "../step_2/index";
import Step3 from "../step_3/index";
import Step4 from "../step_4/index";
import Step5 from "../step_5/index";
import Step6 from "../step_6/index";
import Step7 from "../step_7/index";
import SuccessStep from "../../common/success-step/index";
import Selfie from './../../common/selfie/index';
import { getTypeDocumentsProvider } from "store/actions";
import "../../custom.css";
import { toFile } from "pages/registers/helpers/files-helper";

class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: null,
      current_step: 0,
      is_linkt: true,
      codigoReferencia: 'Linkt-sigmobi',
      form: JSON.parse(localStorage.getItem('form')) || {},
      existingSelfie: null,
      picture: null,
      entityId: 123,
    };
  }
  componentDidMount() {
    const { code } = this.props.match.params
    if (code) {
      this.setState({ codigoReferencia: code, form: { referral_code: code }, is_linkt: false });
    }

    //Reloading provider docs files to form
    const files  = ['cnh', 'crlv', 'foto-veiculo']
    this.state.form.docs?.forEach(async (doc, i) => {
      const fileBase64 = localStorage.getItem(doc.slug)
      if(typeof doc.file === 'object' && fileBase64) {
        const form = {...this.state.form}
        form.docs[i].file = await toFile(fileBase64, doc.name)
        this.setState({form})
      }
    })
  }

  mainSetState = (state) => {
    this.setState(state)
    return this.state
  }

  handleFileImgDrop = ({ file_image, exists_file, image }) => {
    this.setState({ picture: file_image });
  }

  callBackStatusCreate = () => {
    this.setState({ current_step: 8 });
  }

  submitForm = async (data) => {
    var formData = new FormData();
    formData.append('first_name', data.first_name)
    formData.append('last_name', data.last_name)
    formData.append('nick_name', data.nick_name)
    formData.append('gender', data.gender)
    formData.append('email', data.email)
    formData.append('phone', data.phone)
    formData.append('document', data.document)
    formData.append('car_number', data.car_number)
    formData.append('referral_code', this.state.codigoReferencia)

    data.docs.forEach(function (item, i) {
      formData.append(`docs[${i}][id]`, item.document_id)
      formData.append(`docs[${i}][document_name]`, item.document_name)
      formData.append(`docs[${i}][name]`, item.name)
      formData.append(`docs[${i}][file]`, item.file)
    })

    formData.append('picture', this.state.picture)
    formData.append('password', data.password)
    formData.append('confirm_password', data.confirm_password)

    formData.append('pix_key', data.pix_key)
    formData.append('pix_key_type', data.pix_key_type)

    formData.append('zipcode', data.zipcode)
    formData.append('address', data.address)
    formData.append('address_city', data.address_city)
    formData.append('address_complements', data.address_complements || '')
    formData.append('address_neighbour', data.address_neighbour)
    formData.append('address_number', data.address_number)
    formData.append('state', data.state)
    formData.append('latitude', data.latitude)
    formData.append('longitude', data.longitude)

    formData.append('term_of_use', data?.term_of_use)

    this.props.createProvider(formData, this.callBackStatusCreate)
  }

  upateForm = (data) => {
    const form = { ...this.state.form, ...data }
    if(this.props.latitude && this.props.longitude){
      form.latitude = this.props.latitude
      form.longitude = this.props.longitude
    }
    localStorage.setItem('form', JSON.stringify(form))
    this.setState({ form, current_step: 0 })
  }

  back = () => {
    const { current_step } = this.state;
    if (current_step <= 7) {
      this.setState({ current_step: 0 });
    }
  }

  nextStep = () => {
    const { current_step } = this.state;
    if (current_step <= 8) {
      this.setState({ current_step: current_step + 1 });
    }
  }

  renderStep = () => {
    const { current_step } = this.state;

    const stepsMap = {
      1: <Step1 back={this.back} handleFileImgDrop={this.handleFileImgDrop} submit={this.upateForm} form={this.state.form} />,
      2: <Step2 back={this.back} submit={this.upateForm} form={this.state.form} />,
      3: <Step3 hidden_ref_code={this.state.is_linkt} back={this.back} submit={this.upateForm} form={this.state.form} />,
      4: <Step4 back={this.back} submit={this.upateForm} form={this.state.form} />,
      5: <Step5 back={this.back} submit={this.upateForm} state={this.state} form={this.state.form} getPostalCode={getPostalCode} />,
      6: <Step6 back={this.back} submit={this.upateForm} form={this.state.form} getTypeDocumentsProvider={getTypeDocumentsProvider} />,
      7: <Step7 back={this.back} submit={this.upateForm} form={this.state.form} />,
      8: <SuccessStep mainSetState={this.mainSetState} type_form={1} />
    };

    return stepsMap[current_step] || null;
  };

  getCheckSteps = () => {
    return [
      //step 0 picture
      [this.state?.picture].every(v => v),
      //step 1
      [
        this.state.form?.first_name,
        this.state.form?.last_name,
        this.state.form?.gender
      ].every(v => v),
      //step 2
      [
        this.state.form?.document,
        this.state.form?.phone
      ].every(v => v),
      //step 3
      [
        this.state.form?.email,
        this.state.form?.password,
        this.state.form?.confirm_password
      ].every(v => v),
      //step 4
      [
        this.state.form?.pix_key,
        this.state.form?.pix_key_type
      ].every(v => v),
      //step 5
      [
        this.state.form?.zipcode,
        this.state.form?.address_city,
        this.state.form?.address_neighbour,
        this.state.form?.address,
        this.state.form?.country,
        this.state.form?.state,
        this.state.form?.latitude,
        this.state.form?.longitude,
      ].every(v => v),
      [
        this.state.form?.cnh,
        this.state.form?.crlv,
        this.state.form['foto-veiculo']
      ].every(v => v),
      //step 6
      [this.state.form?.term_of_use].every(v => v)
    ]
  }

  isCheckedForm = () => {
    return this.getCheckSteps()?.every(v => !!v)
  }

  iScheckedStep = (step = 0) => {
    return this.getCheckSteps()[step] || false
  }

  render() {
    const { current_step } = this.state;

    return (
      <React.Fragment>
        {current_step == 0 && (
          <div className="container-menu">
            <div className="background"></div>
            <Col className="col-12 col-md-4 col-lg-4">
              <h1 >Cadastro de Motorista</h1>
              <p className="mb-5">Preencha os dados abaixo para se cadastrar.</p>

              <Selfie
                is_avatar={true}
                handleFileImgDrop={this.handleFileImgDrop} // Função para lidar com o upload de uma nova selfie
                img={this.state.existingSelfie} // URL da selfie existente para edição, ou null se for nova
                url_img={this.state.existingSelfie} // URL da imagem a ser exibida inicialmente
                name_product="picture" // Nome associado à imagem (Selfie)
                entity_id={this.state.entityId} // ID do usuário ou entidade
                before_file={null} // Dados adicionais, se necessário
                file_dir_name="selfies" // Diretório onde as selfies serão salvas
              />

              <Card>
                <Card.Body>
                  <Card.Title><MdOutlineSpeakerNotes /> Informações Pessoais</Card.Title>
                  <Button
                    onClick={() => this.setState({ current_step: 1 })}
                    className={this.iScheckedStep(1) ? 'btn-success' : 'btn-light'}
                  >
                    {this.iScheckedStep(1) ? <MdDone /> : <MdEdit />}
                  </Button>
                </Card.Body>
              </Card>

              <Card>
                <Card.Body>
                  <Card.Title><MdEmail /> Contato</Card.Title>
                  <Button
                    onClick={() => this.setState({ current_step: 2 })}
                    className={this.iScheckedStep(2) ? 'btn-success' : 'btn-primary'}
                  >
                    {this.iScheckedStep(2) ? <MdDone /> : <MdEdit />}
                  </Button>
                </Card.Body>
              </Card>

              <Card>
                <Card.Body>
                  <Card.Title><MdOutlineSpeakerNotes /> Acesso</Card.Title>
                  <Button
                    onClick={() => this.setState({ current_step: 3 })}
                    className={this.iScheckedStep(3) ? 'btn-success' : 'btn-primary'}
                  >
                    {this.iScheckedStep(3) ? <MdDone /> : <MdEdit />}
                  </Button>
                </Card.Body>
              </Card>
              <Card>
                <Card.Body>
                  <Card.Title><MdOutlinePix /> Chave PIX</Card.Title>
                  <Button
                    onClick={() => this.setState({ current_step: 4 })}
                    className={this.iScheckedStep(4) ? 'btn-success' : 'btn-primary'}
                  >
                    {this.iScheckedStep(4) ? <MdDone /> : <MdEdit />}
                  </Button>
                </Card.Body>
              </Card>


              <Card>
                <Card.Body>
                  <Card.Title><MdLocationCity />Endereço</Card.Title>
                  <Button
                    onClick={() => this.setState({ current_step: 5 })}
                    className={this.iScheckedStep(5) ? 'btn-success' : 'btn-primary'}
                  >
                    {this.iScheckedStep(5) ? <MdDone /> : <MdEdit />}
                  </Button>
                </Card.Body>
              </Card>

              <Card>
                <Card.Body>
                  <Card.Title><MdLocalTaxi />Documentos e informações do veículo</Card.Title>
                  <Button
                    onClick={() => this.setState({ current_step: 6 })}
                    className={this.iScheckedStep(6) ? 'btn-success' : 'btn-primary'}
                  >
                    {this.iScheckedStep(6) ? <MdDone /> : <MdEdit />}
                  </Button>
                </Card.Body>
              </Card>

              <Card>
                <Card.Body>
                  <Card.Title><MdOutlineImportContacts />Termos e Condições de Uso </Card.Title>
                  <Button
                    onClick={() => this.setState({ current_step: 7 })}
                    className={this.iScheckedStep(7) ? 'btn-success' : 'btn-primary'}
                  >
                    {this.iScheckedStep(7) ? <MdDone /> : <MdEdit />}
                  </Button>
                </Card.Body>
              </Card>

              <Alerts mainSetState={this.mainSetState} lastStep={8} />

              {this.isCheckedForm() && <ButtonGroup className="offset-2 col-8 col-md-6 offset-md-3 col-lg-4 offset-lg-4 mt-3">
                <Button
                  onClick={() => this.submitForm(this.state.form)}
                  className="btn btn-primary btn-large centerButton"
                  type="button"
                >Enviar</Button>
              </ButtonGroup>}
            </Col>

          </div>
        )}

        <div className="container-steps">
          {this.renderStep() && (
            <>
              {this.renderStep()}
            </>
          )}
        </div>
      </React.Fragment>
    );
  }
}

Main.PropTypes = {
  t: PropTypes.any,
  history: PropTypes.any,
  loading: PropTypes.any,
  error: PropTypes.any,
  message: PropTypes.any,
  createProvider: PropTypes.func,
  getTypeDocumentsProvider: PropTypes.func,
  getPostalCode: PropTypes.func,
  id: PropTypes.any,
  address_city: PropTypes.any,
  address_neighbour: PropTypes.any,
  address: PropTypes.any,
  latitude: PropTypes.any,
  longitude: PropTypes.any,
  uf: PropTypes.any,
  idDocument: PropTypes.any,
  name: PropTypes.any,
  required: PropTypes.any,
  has_validity: PropTypes.any,
  slug: PropTypes.any
}

const mapStateToProps = (state) => {
  const {
    id,
    loading,
    address_city,
    address_neighbour,
    address,
    latitude,
    longitude,
    uf
  } = state.Provider;

  const {
    idDocument,
    name,
    required,
    has_validity,
    slug
  } = state.Document;

  return {
    id,
    loading,
    address_city,
    address_neighbour,
    address,
    latitude,
    longitude,
    uf,

    idDocument,
    name,
    required,
    has_validity,
    slug
  };

};


export default withTranslation()(withRouter(connect(mapStateToProps, { createProvider, getTypeDocumentsProvider })(Main)));